import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import showToast from '@/utils/toasts';
import { responseError } from '@/utils/errors';
import ErrorToast from '@/components/toasts/ErrorToast';
import UpdatedToast from '@/components/toasts/UpdatedToast';
import actions from '../constants';

export function* updateVocabularyToast({ result }) {
  yield call(showToast, <UpdatedToast code={result.code} name={result.name} />);
}

export function* updateVocabularyErrorToast(action) {
  yield call(showToast, <ErrorToast
    operation="actions.update"
    name={action.name}
    error={responseError(action).message}
  />);
}

export default function* vocabulariesToasts() {
  yield takeEvery([actions.EDIT_VOCABULARY, actions.RESET_VOCABULARY_SUCCESS], updateVocabularyToast);
  yield takeEvery(actions.RESET_VOCABULARY_ERROR, updateVocabularyErrorToast);
}
